/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type PresidentItem = typeof PresidentItem[keyof typeof PresidentItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PresidentItem = {
  'william-j-clinton': 'william-j-clinton',
  'george-w-bush': 'george-w-bush',
  'barack-obama': 'barack-obama',
  'donald-trump': 'donald-trump',
  'joe-biden': 'joe-biden',
} as const;
